import {ProfileService} from "@/common/api/profile.service";
import {
    PROFILE_GET,
    PROFILE_UPDATE,
    PROFILE_DAYS_OFF_GET,
    PROFILE_LOGO_GET,
    PROFILE_INACTIVE,
    PROFILE_ACTIVE,
    PROFILE_ADD_DAY_OFF,
    PROFILE_DELETE_DAY_OFF
} from "./actions/profile.type";
import {CHANGE_PROGRESS} from "./mutations/mutations.type"
import {
    SET_PROFILE,
    PROFILE_ADD_WEEKDAY,
    PROFILE_REMOVE_WEEKDAY,
    SET_LOGO,
    PROFILE_REMOVE_DAY_OFF,
    PROFILE_RESET_STATE,
    SET_PROFILE_DAYS_OFF,
    SET_PROFILE_DAY_OFF,
    SET_PROFILE_ACTIVE
} from "./mutations/profile.type";
import Vue from "vue";

const initialState = () => {
    return {
        profile: {
            name: "",
            cnpj: "",
            companyName: "",
            fantasyName: "",
            phone: "",
            email: "",
            state: "",
            city: "",
            district: "",
            street: "",
            number: 0,
            desc: "",
            addressComplement: "",
            zipcode: "",
            weekDays: [],
            dayOffs: []
        },
        logo: null,
        profileDayOff: {
            id: 0,
            startDate: null,
            endDate: null
        },
    };
};

export const state = initialState();

const getters = {
    profile: state => {
        return state.profile;
    },
    logo: state => {
        return state.logo
    },
    profileDayOff: state => {
        return state.profileDayOff
    }
};

const mutations = {
    [SET_PROFILE](state, data) {
        state.profile = data;
    },
    [SET_PROFILE_DAYS_OFF](state, data) {
        Vue.set(state.profile, 'dayOffs', data)
    },
    [SET_LOGO](state, data) {
        state.logo = data
    },
    [SET_PROFILE_DAY_OFF](state, data) {
        state.profileDayOff = data
    },
    [PROFILE_REMOVE_DAY_OFF](state, index) {
        state.profile.dayOffs.splice(index, 1)
    },

    [PROFILE_ADD_WEEKDAY](state) {
        if (state.profile.weekDays == null) {
            state.profile.weekDays = []
        }
        state.profile.weekDays.push({id: 0, startTime: null, endTime: null})
    },
    [SET_PROFILE_ACTIVE](state, active) {
        state.profile.active = active
    },
    [PROFILE_REMOVE_WEEKDAY](state, index) {
        state.profile.weekDays.splice(index, 1)
    },
    [PROFILE_RESET_STATE](state) {
        Object.assign(state, initialState());
    }
};

const actions = {
    async [PROFILE_GET]({commit}) {
        commit(CHANGE_PROGRESS, true);
        const {data} = await ProfileService.get();
        commit(SET_PROFILE, data);

        commit(CHANGE_PROGRESS, false)
    },
    async [PROFILE_DAYS_OFF_GET]({commit}) {
        commit(CHANGE_PROGRESS, true);
        const {data} = await ProfileService.get_days_off();
        commit(SET_PROFILE_DAYS_OFF, data);
        commit(CHANGE_PROGRESS, false)
    },
    async [PROFILE_UPDATE]({state}) {
        return ProfileService.update("", state.profile);
    },
    async [PROFILE_LOGO_GET]({commit}) {
        // commit(CHANGE_PROGRESS, true);
        const data = await ProfileService.get_logo();
        commit(SET_LOGO, data);
        // commit(CHANGE_PROGRESS, false)
    },
    async [PROFILE_ADD_DAY_OFF]({state}) {
        return ProfileService.addDayOff({
            startDate: state.profileDayOff.startDate,
            endDate: state.profileDayOff.endDate
        });
    },
    async [PROFILE_DELETE_DAY_OFF](_, id) {
        return ProfileService.deleteDayOff(id);
    },
    [PROFILE_ACTIVE]() {
        return ProfileService.active()
    },
    [PROFILE_INACTIVE]() {
        return ProfileService.inactive()
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
